<script setup lang="ts">
import ConfirmDialog from "primevue/confirmdialog";

const dialogTypes = ["warning", "success", "message"];
</script>

<template>
  <ConfirmDialog
    v-for="type in dialogTypes"
    :key="`confirm_dialog_${type}`"
    :group="type"
    :pt-options="{ mergeProps: true }"
    :pt="{
      root: 'max-w-5xl m-2',
    }"
  >
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div
        :class="[
          'flex flex-col gap-7 rounded-xl border border-surface-border bg-black px-5 py-12 text-white lg:px-36 lg:py-20',
        ]"
      >
        <div
          v-if="message.header"
          :class="[
            'flex items-center justify-center',
            { 'text-red-700': type === 'warning' },
            { 'text-green-500': type === 'success' },
          ]"
        >
          <font-awesome-icon
            :icon="
              type === 'warning' || type === 'message'
                ? ['fas', 'circle-exclamation']
                : ['fas', 'circle-check']
            "
            class="mr-4 mt-0.5 text-2xl"
          />
          <span class="text-xl lg:text-3xl">
            {{ message.header }}
          </span>
        </div>
        <div
          :class="['text-center text-base text-surface-300 lg:text-lg']"
          v-html="message.message"
        />
        <div class="flex justify-center gap-5">
          <Button
            v-if="message.acceptProps"
            class="w-1/2"
            :label="message.acceptProps.label"
            :pt="{ root: ['px-5'], label: ['font-semibold'] }"
            :pt-options="{ mergeProps: true }"
            :outlined="message.acceptProps.outlined"
            @click="acceptCallback"
          />
          <Button
            v-if="message.rejectProps"
            class="w-1/2"
            outlined
            severity="secondary"
            :pt="{
              root: ['px-5 border-white'],
              label: ['font-semibold text-white'],
            }"
            :pt-options="{ mergeProps: true }"
            :label="message.rejectProps.label"
            @click="rejectCallback"
          />
        </div>
      </div>
    </template>
  </ConfirmDialog>
</template>

<style scoped></style>
